import React from "react";
import { Layout, Typography } from "antd";
import { CONTACT_INFO } from "../config";

const { Footer: AntFooter } = Layout;
const { Text } = Typography;

const Footer = () => {
  return (
    <AntFooter style={{ textAlign: "center", padding: "20px 16px" }}>
      <Text style={{ wordBreak: "break-word" }}>
        <strong>Email: </strong>
        <a href={`mailto:${CONTACT_INFO.email}`}>{CONTACT_INFO.email}</a>
      </Text>
      <br />
      <Text style={{ wordBreak: "break-word" }}>
        <strong>Telegram channel: </strong>
        <a
          href={`https://short.upfellow.com/followusfooter`}
          target="_blank"
          rel="noopener noreferrer"
        >
          @{CONTACT_INFO.telegramChannelName}
        </a>
      </Text>
    </AntFooter>
  );
};

export default Footer;
